import { ContentTitle } from "components/ContentTitle";
import HomeBackground from "assets/HomeBackground.png";
import { BreadCrumbs } from "components/BreadCrumbs";
import { Title } from "components/Title";
import { DaySelector } from "components/DaySelector";
import { Images, dataDays } from "helpers/Consts";
import { TourDayDetail } from "components/TourDayDetail";
import { Container } from "components/Container";
import { Box } from "@mui/material";
import { RelatedTours } from "components/RelatedTours";
import { SectionAdditional } from "./Components/SectionAdditional";

export const TourDetail = () => {
  return (
    <>
      <ContentTitle title="Cusco" img={HomeBackground} />
      <BreadCrumbs
        items={[
          {
            label: "Tour",
            to: "/tours"
          },
          {
            label: "Cusco",
            to: "/tours-detail"
          }
        ]}
        pl={{ lg: 41, md: 4, sm: 10, xs: 4 }}
      />
      <Container>
        <Title mt={10}>¡Atrévete a conocer Cusco en pocos días!</Title>
        <Box mb={20}>
          <DaySelector days={dataDays} />
        </Box>
        <TourDayDetail
          image={Images}
          title="Día 1"
          description="Descubre Cusco: unión de pasado inca y legado colonial. Adéntrate en templos, fortalezas y escenarios andinos, conectando con la esencia de Perú."
          subtitle="CUSCO - CITY TOUR"
        />
      </Container>
      <SectionAdditional />
      <RelatedTours />
    </>
  );
};
